var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17.4,
    r: 15,
    fill: "#00A7A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6133 19.0234H15.9844V23.6523H14.0508V19.0234H9.42188V17.0898H14.0508V12.4492H15.9844V17.0898H20.6133V19.0234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddTeal);
export default __webpack_public_path__ + "static/media/Icon_Add_Teal.3674bb02cd8ee8370a979506ad59ed03.svg";
export { ForwardRef as ReactComponent };